import { REPO_CONFIG } from "../constants"
import type { RepoName } from "../types"

export function getRepoFromPath(path: string): RepoName | null {
  for (const [key, config] of Object.entries(REPO_CONFIG)) {
    if (path.includes(config.pathSegment)) {
      return key as RepoName
    }
  }
  return null
}

export function getCurrentRepo(): RepoName | null {
  if (typeof window === "undefined") return null
  return getRepoFromPath(window.location.pathname)
}
